import useToast from '~/assets/js/composables/layout/useToast';

function init_goftino() {
  ['keydown', 'touchmove', 'touchstart', 'mouseover'].forEach(v => {
    window.addEventListener(v, () => {
      if (!window.isGoftinoAdded) {
        window.isGoftinoAdded = 1;
        const i = import.meta.env.VITE_GOFTINO_ID;
        const d = document;
        const g = d.createElement('script');
        const s = `https://www.goftino.com/widget/${i}`;
        const l = localStorage.getItem(`goftino_${i}`);
        (g.type = 'text/javascript'), (g.async = !0), (g.src = l ? `${s}?o=${l}` : s);
        d.getElementsByTagName('head')[0].appendChild(g);
      }
    });
  });
}

function config_goftino() {
  Goftino.setWidget({
    hasIcon: false,
    counter: '.goftino_unread_count',
    marginRight: 30,
    marginLeft: 30,
    marginBottom: 30,
    hasSound: false,
  });
}

function set_goftino_user(user, goftino_id = null) {
  // if (goftino_id)
  //   Goftino.setUserId(goftino_id);
  Goftino.setUser({
    name: user.name,
    phone: user.mobile,
    about: '',
    // email: "test@email.com",
    // avatar: "http://goftino.com/mypic.jpg",
    // tags: "tag1,tag2,tag3",
    forceUpdate: true,
  });

  tick_goftino();
}

function tick_goftino() {
  // Goftino.open();
  // Goftino.close();
}

const toggle_goftino = () => {
  Goftino.toggle();
};

const hide_goftino = () => {
  Goftino.close();
};

const open_goftino = () => {
  Goftino.open();
};

const send_goftino_message = text => {
  if (!Goftino) {
    useToast().create_warning('خطا، چند لحظه دیگر تلاش کنید یا اینکه صفحه را رفرش کنید.');
    return;
  }

  Goftino.sendMessage({
    text,
  });
  open_goftino();
};

function load_goftino() {
  init_goftino();

  window.addEventListener('goftino_ready', () => {
    config_goftino();
  });

  return true;
}

export {
  init_goftino,
  config_goftino,
  set_goftino_user,
  load_goftino,
  tick_goftino,
  toggle_goftino,
  hide_goftino,
  open_goftino,
  send_goftino_message,
};
